"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function setName(betValue) {
    return {
        type: types_1.SET_NAME_VALUE,
        payload: betValue
    };
}
exports.setName = setName;
function resetName() {
    return {
        type: types_1.RESET_NAME_VALUE
    };
}
exports.resetName = resetName;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/name/actions.ts
// module id = 188
// module chunks = 5